import Link from "next/link";
import { authorPath } from "@/lib/articles/normalizeAuthors";

export default function ArticleAuthorLinks({ article, className = "" }) {
  const authors = article?.authors?.length ? article.authors : [{ name: typeof article?.author === "string" ? article.author : article?.author?.name,
    id: article?.authorId || article?.author?.id,
    url: article?.authorUrl }];
  return <span className={className}>{authors.filter(author => author?.name).map((author, index) => <span key={author.id || author.slug || index}>
    {index > 0 && ", "}{authorPath(author) ? <Link href={author.url || authorPath(author)} data-author-link={author.id || author.slug}>{author.name}</Link> : author.name}
  </span>)}</span>;
}
